var _circle, _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "#003B6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_21254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8752 6.50002C14.2056 6.50002 14.538 6.51714 14.8679 6.53132C15.083 6.54012 15.298 6.56996 15.5 6.59099L15.4849 8.52349H15.3267C15.1082 8.52349 14.8901 8.52056 14.672 8.52056C14.5083 8.52056 14.3446 8.52056 14.1804 8.52741C13.6536 8.54452 13.2653 8.73674 13.2381 9.37602C13.2215 9.83677 13.2094 10.8541 13.2089 10.9074C13.2361 10.9074 13.7574 10.9074 14.2817 10.9074C14.5441 10.9074 14.8004 10.9074 14.9787 10.9074H15.4048C15.298 11.6494 15.1998 12.3621 15.0936 13.0786H13.2094L13.1671 18.5H10.8504L10.8927 13.0708H9L9.01712 10.9123H10.9189V10.75C10.9224 10.3151 10.9189 9.87981 10.9335 9.44499C10.9359 9.16773 10.9601 8.89107 11.006 8.6174C11.0569 8.29662 11.1727 7.98881 11.3468 7.71177C11.5209 7.43472 11.7498 7.19393 12.0203 7.00332C12.5104 6.67376 13.0928 6.49809 13.6889 6.50002C13.7524 6.5005 13.8138 6.50002 13.8752 6.50002Z",
    fill: "#003B6F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 13,
    height: 13,
    rx: 4,
    fill: "#003B6F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_21254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.777 7.85744C14.0838 7.85744 14.3925 7.87333 14.6988 7.88651C14.8985 7.89468 15.0982 7.92238 15.2857 7.94191L15.2717 9.73638H15.1248C14.9219 9.73638 14.7194 9.73365 14.5169 9.73365C14.3649 9.73365 14.2129 9.73365 14.0604 9.74001C13.5712 9.75591 13.2107 9.9344 13.1854 10.528C13.17 10.9558 13.1588 11.9005 13.1583 11.95C13.1835 11.95 13.6676 11.95 14.1544 11.95C14.3981 11.95 14.6361 11.95 14.8017 11.95H15.1973C15.0982 12.639 15.007 13.3008 14.9083 13.9662H13.1588L13.1195 19.0003H10.9682L11.0075 13.9589H9.25L9.2659 11.9546H11.0318V11.8038C11.0351 11.4 11.0318 10.9958 11.0454 10.5921C11.0476 10.3346 11.0701 10.0777 11.1127 9.82358C11.16 9.52571 11.2675 9.23989 11.4292 8.98264C11.5909 8.72538 11.8034 8.50179 12.0546 8.32479C12.5097 8.01877 13.0505 7.85565 13.604 7.85744C13.6629 7.85789 13.72 7.85744 13.777 7.85744Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_21254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_21254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.1429,
    height: 11.1429,
    fill: "white",
    transform: "translate(6.92871 7.85742)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.da99a77f76b8689eeb0e76d76fcb1428.svg";
export { ForwardRef as ReactComponent };